import styled, { keyframes } from 'styled-components'
import { SimpleButtonProps } from '.'

type ContainerProps = Omit<SimpleButtonProps, 'hasAnimation'> & {
  $hasAnimation?: boolean;
}

export const Container = styled.button<ContainerProps>`
  width: 100%;
  min-height: 7vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ bg }) => bg || 'linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%);'};
  border: 2px solid #606060;
  opacity: ${({ disabled }) => disabled === true ? 0.1 : 1};
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.5);
  border-radius: 10vw;
  font-family: Poppins;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.2;
  color: ${({ color }) => color || '#000'};
  cursor: ${({ disabled }) => disabled === true ? 'default' : 'pointer'};
  
  ${({ $hasAnimation }) => $hasAnimation && 'animation: blink 3s linear infinite;'}

  @keyframes blink {
    0% {
      background: ${({ bg }) => bg || 'linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%);'};
    }

    50% {
      background: #FFFFFF;
    }

    100% {
      background: ${({ bg }) => bg || 'linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%);'};
    }
  }
`

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div<SimpleButtonProps>`
  width: 30px;
  height: 30px;
  border: 4px solid transparent;
  border-left-color: ${({ color }) => color || '#fff'};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`
